import React from "react";
import {
  FieldError,
  type FieldErrorProps as AriaFieldErrorProps,
  type ValidationResult,
} from "react-aria-components";

export type FieldErrorProps = {
  errorMessage: string | ((validation: ValidationResult) => string);
} & AriaFieldErrorProps;

export function FieldError2({ errorMessage, ...props }: FieldErrorProps) {
  return (
    <FieldError className="tw:text-xs tw:text-text-error-primary" {...props}>
      {errorMessage}
    </FieldError>
  );
}
